import { Button, Label, Modal, Spinner, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../utils/Auth/AuthProvider';
import { useAddSubChapter, useSubChapters } from '../../react-query/queries';

interface SubchapterDialogProps {
  isOpen: boolean;
  onClose: () => void;
  chapterId: number | null;
  chapterName: string;
}

const SubchapterDialog: React.FC<SubchapterDialogProps> = ({
  isOpen,
  onClose,
  chapterId,
  chapterName,
}) => {
  const { token } = useAuth();
  const { data: subchaptersData, refetch: refetchSubchaps, isFetching } = useSubChapters(token, chapterId);
  const addSubchapter = useAddSubChapter();
  const [newSubchapter, setNewSubchapter] = useState('');

  useEffect(() => {
    if (isOpen && chapterId) {
      refetchSubchaps();
    }
  }, [isOpen, chapterId, refetchSubchaps]);

  const doAddSubchapter = async () => {
    if (!newSubchapter.trim() || !chapterId) return;
    await addSubchapter.mutateAsync({ toBeValidated: token, chapterId, name: newSubchapter.trim() });
    setNewSubchapter('');
    refetchSubchaps();
  };

  return (
    <Modal show={isOpen} onClose={onClose} size="lg" className="z-[9999]">
      <Modal.Header>Subchapters for: {chapterName}</Modal.Header>
      <Modal.Body>
        <div className="mb-3 flex gap-2">
          <TextInput
            className="flex-grow"
            value={newSubchapter}
            onChange={(e) => setNewSubchapter(e.target.value)}
            placeholder="New subchapter name"
          />
          <Button size="sm" onClick={doAddSubchapter} isProcessing={addSubchapter.isPending}>Add</Button>
        </div>

        {isFetching ? (
          <p className="text-sm text-gray-500">Loading subchapters…</p>
        ) : subchaptersData?.subchapters?.length ? (
          <div className="divide-y divide-gray-100 rounded border border-gray-100 dark:divide-gray-700 dark:border-gray-700">
            {subchaptersData.subchapters.map((sc: any) => (
              <div key={sc.id} className="flex items-center justify-between px-3 py-2">
                <span className="font-medium">{sc.name}</span>
                <span className="text-xs text-gray-500">ID: {sc.id}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="rounded border border-dashed border-gray-200 p-4 text-center text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">No subchapters yet. Add one above.</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubchapterDialog;
